import {Component, Input, TemplateRef, ViewChild} from '@angular/core';
import {AuthService} from "../../services/auth/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {AuditLogPage} from "../../generated/sales-terminal-client";
import {SelfServiceEventService} from "../../services/self-service/event/self-service-event.service";
import {tap} from "rxjs";
import {UtilService} from "../../services/util/util.service";

@Component({
  selector: 'app-event-audit-log-table-dialog',
  templateUrl: './event-audit-log-table-dialog.component.html',
  styleUrls: ['./event-audit-log-table-dialog.component.scss']
})
export class EventAuditLogTableDialog {
  @ViewChild('auditLogTableDialog')
  private auditDialog: TemplateRef<any>;

  @Input() eventId: number;
  public isLoading: boolean;
  public auditLogPage: AuditLogPage;
  public auditPageNumber: number = 1;
  private auditPageSize: number = 30;

  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private selfServiceEventService: SelfServiceEventService,
    public utilService: UtilService,
  ) {}

  public get canSeeAuditLogs(): boolean {
    return this.authService.hasAuditGetPrivilege && this.authService.hasSelfServiceEventsViewPrivilege;
  }

  public showAuditLogs(): void {
    const dialogRef = this.dialog.open(this.auditDialog, {
      width: '80%'
    });
    dialogRef.afterOpened().subscribe(() => {
      this.isLoading = true;
      this.getAuditLogs();
    });
    dialogRef.afterClosed().subscribe(() => {
      this.auditLogPage = null;
    });
  }

  public getAuditLogs(): void {
    if (this.canSeeAuditLogs) {
      this.isLoading = true;
      this.selfServiceEventService.getAuditLogs(this.eventId, this.auditPageNumber, this.auditPageSize)
        .pipe(tap({ error: () => this.isLoading = false }))
        .subscribe((auditPage: AuditLogPage) => {
          this.auditLogPage = auditPage;
          this.isLoading = false;
        });
    }
  }

}
